import {Component, input} from '@angular/core';
import {HandicapMode, ScoringMethod, ScoringMethodType, ScoringSettings} from "../model/round-history";
import {NgIf} from "@angular/common";

@Component({
    standalone: true,
    selector: 'score',
    templateUrl: './score.component.html',
    imports: [
        NgIf
    ],
    styleUrls: ['score.component.css']
})
export class ScoreComponent {
    readonly totalGrossScore = input.required<number>();
    readonly totalScorePoints = input.required<string>();
    readonly scoringSettings = input.required<ScoringSettings>();

    shortLabel(scoringMethod: ScoringMethod, handicapMode: HandicapMode): string {
        switch (scoringMethod.type) {
            case ScoringMethodType.Stableford:
                return 'Pts'
            case ScoringMethodType.StrokePlay:
                return handicapMode === HandicapMode.Gross ? 'Gross' : 'Net';
            case ScoringMethodType.MathPlay:
                return 'Pts'
            case ScoringMethodType.Nines:
                return 'Pts'
            case ScoringMethodType.Skins:
                return 'Skins'
            default:
                return ''
        }
    }
}
